const Thrillers = () => (
  <h1>Thrillers</h1>
);

export default Thrillers;
